/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect } from "react";
import {
  TbBriefcase,
  TbBuilding,
  TbBuildingCommunity,
  TbCalendar,
  TbCalendarEvent,
  TbCalendarTime,
  TbClockHour4,
  TbCurrencyRupee,
  TbDroplet,
  TbGenderBigender,
  TbHeart,
  TbHeartHandshake,
  TbMail,
  TbMap2,
  TbMapPin,
  TbMapPins,
  TbPencil,
  TbPhoneCall,
  TbPhotoPin,
  TbPlaylistAdd,
  TbSchool,
  TbUserPlus,
  TbUsers,
  TbUsersGroup,
  TbWorld,
} from "react-icons/tb";

import { useEmployeeContext } from "../../../context/employee-context";
import { Box, Button, FabButton, Flex, Icon, Typography } from "../../../ppui";
import {
  formatToCustomDate,
  parseNumericValue,
  toCapitaliseAllString,
  toCapitaliseStringType1,
} from "../../../utils/common";
import { logger } from "../../../utils/logger";
import {
  Card,
  CardHeading,
  OrganizationBx,
  OrganizationEmDetails,
} from "../../style";
import ProfileDialog from "./profile-dialog";

const EmployeeProfileView = ({
  EmployeedetailsModalOpen,
  PresentaddressModalClose,
  PresentaddressModalOpen,
  PermanentaddressModalClose,
  PermanentaddressModalOpen,
  PersonalInformationModalClose,
  PersonalInformationModalOpen,
  EmployeedetailsModalClose,
  Permanentaddress,
  PersonalInformation,
  Presentaddress,
  Employeedetails,
  getInputFieldProps,
  employeeProfileInput,
  handleClick,
  createFormUpdateLoading,
  setEmployeeProfileInput,
  id,
}) => {
  const {
    departmentList,
    designationList,
    employeeInfo,
    branchList,
    stateList,
    shiftManagement,
    getExitFormality,
  } = useEmployeeContext() || {};
  logger.log(employeeInfo, "employeeInfo999");
  useEffect(() => {
    getExitFormality(id);
  }, []);
  return (
    <>
      <Card>
        <CardHeading Divider>
          Employee Details
          <FabButton
            size="sm"
            icon={<TbPencil />}
            onClick={EmployeedetailsModalOpen}
            variant="filled"
            shape="box"
          />
        </CardHeading>
        <OrganizationEmDetails>
          <OrganizationBx>
            <Icon size={"lg"}>
              <TbUsers /> {/* Suitable for Employment Type */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Employment Type
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.employment_type
                  ? employeeInfo?.employment_type === "full_time"
                    ? "Permanent" // Consistent casing
                    : employeeInfo?.employment_type === "part_time"
                      ? "Part Time"
                      : employeeInfo?.employment_type === "probationary"
                        ? "Provision Period"
                        : employeeInfo?.employment_type === "contractual"
                          ? toCapitaliseStringType1(
                              employeeInfo?.employment_type
                            )
                          : "N/A" // Use N/A instead of -
                  : "--"}{" "}
                Employee
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbCurrencyRupee /> {/* Suitable for Salary Type */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Salary Type
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.salary_type
                  ? toCapitaliseStringType1(employeeInfo?.salary_type)
                  : "N/A"}
              </Typography>
            </Box>
          </OrganizationBx>

          {employeeInfo.employment_type === "probationary" && (
            <OrganizationBx>
              <Icon size={"lg"}>
                <TbCalendarTime /> {/* Suitable for Provision Period */}
              </Icon>
              <Box>
                <Typography variant="body1" mb={"0"} color="primary">
                  Provision Period
                </Typography>
                <Typography
                  variant="body2"
                  mb={"0"}
                  color="dark"
                  colorVariant="light"
                  textCase="capitalize"
                >
                  {employeeInfo?.provision_period_days
                    ? parseNumericValue(employeeInfo?.provision_period_days)
                    : "N/A"}
                </Typography>
              </Box>
            </OrganizationBx>
          )}

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbCalendarEvent /> {/* Suitable for Joining Date */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Joining Date
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.join_date
                  ? formatToCustomDate(new Date(employeeInfo?.join_date))
                  : "N/A"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbBuilding /> {/* Suitable for Branch Name */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Branch Name
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.branch_id
                  ? toCapitaliseStringType1(
                      branchList?.find(
                        (it) => it?.id === employeeInfo?.branch_id
                      )?.name || "N/A" // Handle missing branch
                    )
                  : "N/A"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbUsersGroup /> {/* Suitable for Department */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Department
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.department_id
                  ? toCapitaliseStringType1(
                      departmentList?.find(
                        (it) => it?.id === employeeInfo?.department_id
                      )?.name || "--" // Handle missing department
                    )
                  : "--"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbBriefcase /> {/* Suitable for Designation */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Designation
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.designation_id
                  ? toCapitaliseStringType1(
                      designationList?.find(
                        (it) => it?.id === employeeInfo?.designation_id
                      )?.name || "--" // Handle missing designation
                    )
                  : "--"}
              </Typography>
            </Box>
          </OrganizationBx>

          {shiftManagement && (
            <OrganizationBx>
              <Icon size={"lg"}>
                <TbClockHour4 /> {/* Suitable for Shifts Type */}
              </Icon>
              <Box>
                <Typography variant="body1" mb={"0"} color="primary">
                  Shifts Type
                </Typography>
                <Typography
                  variant="body2"
                  mb={"0"}
                  color="dark"
                  colorVariant="light"
                  textCase="capitalize"
                >
                  {employeeInfo?.shift_type
                    ? toCapitaliseStringType1(employeeInfo?.shift_type)
                    : "--"}
                </Typography>
              </Box>
            </OrganizationBx>
          )}

          {employeeInfo?.employment_type == "contractual" && (
            <>
              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbCalendarTime /> {/* Suitable for Contract Start */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Contract Start
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {employeeInfo?.contract_start
                      ? formatToCustomDate(
                          new Date(employeeInfo?.contract_start)
                        )
                      : "--"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbCalendarTime /> {/* Suitable for Contract End */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Contract End
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {employeeInfo?.contract_end
                      ? formatToCustomDate(new Date(employeeInfo?.contract_end))
                      : "--"}
                  </Typography>
                </Box>
              </OrganizationBx>
            </>
          )}
        </OrganizationEmDetails>
      </Card>
      <Card>
        <CardHeading Divider>
          Personal Information
          <FabButton
            size="sm"
            icon={<TbPencil />}
            onClick={PersonalInformationModalOpen}
            variant="filled"
            shape="box"
          />
        </CardHeading>
        <OrganizationEmDetails>
          <OrganizationBx>
            <Icon size={"lg"}>
              <TbCalendar /> {/* Suitable for DOB */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                DOB
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.date_of_birth
                  ? formatToCustomDate(new Date(employeeInfo?.date_of_birth))
                  : "--"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbSchool />
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Qualification
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {/* {employeeInfo?.qualification ? toCapitaliseStringType1(getQualificationName(employeeInfo?.qualification)) : "--"} */}
                {employeeInfo?.qualification
                  ? toCapitaliseStringType1(employeeInfo?.qualification)
                  : "--"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbGenderBigender />
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Gender
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.gender
                  ? toCapitaliseStringType1(employeeInfo?.gender)
                  : "--"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbDroplet />
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Blood Group
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.blood_group
                  ? toCapitaliseStringType1(employeeInfo?.blood_group)
                  : "--"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbHeart />
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Marital Status
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.marital_status
                  ? toCapitaliseStringType1(employeeInfo?.marital_status)
                  : "--"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbMail /> {/* Suitable for Personal Email */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Personal Email
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.personal_email || "--"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbPhoneCall /> {/* Suitable for Alternative Phone */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Alternative Phone
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.alternative_phone || "--"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbUserPlus /> {/* Suitable for Guardian Name */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Guardian Name
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.guardian_name
                  ? toCapitaliseAllString(employeeInfo?.guardian_name)
                  : "--"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbHeartHandshake /> {/* Suitable for Relation With Guardian */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Relation With Guardian
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.guardian_relationship
                  ? toCapitaliseStringType1(employeeInfo?.guardian_relationship)
                  : "--"}
              </Typography>
            </Box>
          </OrganizationBx>
        </OrganizationEmDetails>
      </Card>
      <Card>
        <CardHeading Divider>
          Permanent Address
          <FabButton
            size="sm"
            icon={<TbPencil />}
            onClick={PermanentaddressModalOpen}
            variant="filled"
            shape="box"
          />
        </CardHeading>
        <OrganizationEmDetails>
          <OrganizationBx>
            <Icon size={"lg"}>
              <TbMapPin /> {/* Suitable for Address */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Address
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.permanent_address
                  ? toCapitaliseStringType1(employeeInfo?.permanent_address)
                  : "--"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbBuildingCommunity /> {/* Suitable for City/District */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                City/District
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.permanent_city
                  ? toCapitaliseStringType1(employeeInfo?.permanent_city)
                  : "--"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbMap2 /> {/* Suitable for State */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                State
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.present_state
                  ? stateList?.find(
                      (it) => it?.id === employeeInfo?.present_state
                    )?.state_name || "--" // Handle missing state
                  : "--"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbWorld /> {/* Suitable for Country */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Country
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                India
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbMapPins /> {/* Suitable for Pin Code */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Pin Code
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.permanent_pincode || "--"}
              </Typography>
            </Box>
          </OrganizationBx>

          <OrganizationBx>
            <Icon size={"lg"}>
              <TbPhotoPin /> {/* Suitable for Landmark */}
            </Icon>
            <Box>
              <Typography variant="body1" mb={"0"} color="primary">
                Landmark
              </Typography>
              <Typography
                variant="body2"
                mb={"0"}
                color="dark"
                colorVariant="light"
                textCase="capitalize"
              >
                {employeeInfo?.permanent_landmark
                  ? toCapitaliseStringType1(employeeInfo?.permanent_landmark)
                  : "--"}
              </Typography>
            </Box>
          </OrganizationBx>
        </OrganizationEmDetails>
      </Card>

      {/* {!employeeInfo?.is_same_permanent && <> */}
      {(employeeInfo?.present_address ||
        employeeInfo?.present_city ||
        employeeInfo?.present_state ||
        employeeInfo?.present_pincode ||
        employeeInfo?.present_landmark) && (
        <>
          <Card>
            <CardHeading Divider>
              Present Address
              <FabButton
                size="sm"
                icon={<TbPencil />}
                onClick={PresentaddressModalOpen}
                variant="filled"
                shape="box"
              />
            </CardHeading>
            <OrganizationEmDetails>
              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbMapPin /> {/* Suitable for Address */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Address
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {employeeInfo?.present_address
                      ? toCapitaliseStringType1(employeeInfo?.present_address)
                      : "--"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbBuildingCommunity /> {/* Suitable for City/District */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    City/District
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {employeeInfo?.present_city
                      ? toCapitaliseStringType1(employeeInfo?.present_city)
                      : "--"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbMap2 /> {/* Suitable for State */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    State
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {employeeInfo?.present_state
                      ? stateList?.find(
                          (it) => it?.id === employeeInfo?.present_state
                        )?.state_name || "--" // Handle missing state
                      : "--"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbWorld /> {/* Suitable for Country */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Country
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    India
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbMapPins /> {/* Suitable for Pin Code */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Pin Code
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {employeeInfo?.present_pincode || "--"}
                  </Typography>
                </Box>
              </OrganizationBx>

              <OrganizationBx>
                <Icon size={"lg"}>
                  <TbPhotoPin /> {/* Suitable for Landmark */}
                </Icon>
                <Box>
                  <Typography variant="body1" mb={"0"} color="primary">
                    Landmark
                  </Typography>
                  <Typography
                    variant="body2"
                    mb={"0"}
                    color="dark"
                    colorVariant="light"
                    textCase="capitalize"
                  >
                    {employeeInfo?.present_landmark
                      ? toCapitaliseStringType1(employeeInfo?.present_landmark)
                      : "--"}
                  </Typography>
                </Box>
              </OrganizationBx>
            </OrganizationEmDetails>
          </Card>
        </>
      )}
      {!(
        employeeInfo?.present_address ||
        employeeInfo?.present_city ||
        employeeInfo?.present_state ||
        employeeInfo?.present_pincode ||
        employeeInfo?.present_landmark
      ) && (
        <Card>
          <CardHeading Divider>
            Present Address
            <Button
              onClick={() => PresentaddressModalOpen()}
              icon={<TbPlaylistAdd />}
              color="primary"
              size="sm"
              variant="contained"
            >
              Add
            </Button>
          </CardHeading>

          <Flex alignItem="center">
            <Typography variant="body2" mb={"0"} color="primary">
              Please enter present address details for better visibility.
            </Typography>
            <Button
              color="secondary"
              size="sm"
              onClick={() => PresentaddressModalOpen()}
            >
              Click here
            </Button>
          </Flex>
        </Card>
      )}

      <ProfileDialog
        createFormUpdateLoading={createFormUpdateLoading}
        employeeProfileInput={employeeProfileInput}
        getInputFieldProps={getInputFieldProps}
        Presentaddress={Presentaddress}
        PresentaddressModalClose={PresentaddressModalClose}
        PermanentaddressModalClose={PermanentaddressModalClose}
        Permanentaddress={Permanentaddress}
        PersonalInformationModalClose={PersonalInformationModalClose}
        PersonalInformation={PersonalInformation}
        EmployeedetailsModalClose={EmployeedetailsModalClose}
        Employeedetails={Employeedetails}
        handleClick={handleClick}
        setEmployeeProfileInput={setEmployeeProfileInput}
      />
    </>
  );
};

export default EmployeeProfileView;
